// extracted by mini-css-extract-plugin
export default {"container":"_404_container__Z1X9S","textSection":"_404_textSection__i9PBZ","imageSection":"_404_imageSection__HiMrX"};